export function assertNever(obj: never): never {
    throw throwError(`Unexpected obj: ${JSON.stringify(obj)}`);
}

export namespace ObjIter {
    export function map<T, K extends keyof T, U>(obj: T, fn: (v: T[keyof T], k: K) => U): Array<U> {
        const res = [] as Array<U>;
        const keys = Object.keys(obj) as K[];
        keys.forEach((it) => {
            res.push(fn(obj[it], it));
        });
        return res;
    }

    export function forEach<T, K extends keyof T>(obj: T | undefined, fn: (v: T[K], k: K) => any) {
        if (!obj) return;
        let keys = Object.keys(obj);
        keys.forEach((it: any) => {
            fn((obj as any)[it], it);
        });
    }
}

export function throwError(msg: string, ...debugOutput: Array<any>): never {
    console.error(msg, debugOutput);
    throw new Error(msg);
}

export function indexOfUndefined(...args: Array<any>): number {
    for (let i = 0; i < args.length; i++) {
        if (args[i] === undefined) return i;
    }

    return -1;
}

export function strEnum<T extends string>(o: Array<T>): { [K in T]: K } {
    return o.reduce((res, key) => {
        res[key] = key;
        return res;
    }, Object.create(null));
}

export class Timings {
    static Empty = { min: Number.MAX_VALUE, max: Number.MIN_VALUE, avg: 0, samples: 0 };

    static create(id: string = "timer"): Timings {
        return new Timings(id, { ...Timings.Empty }, -9999999, false);
    }

    get samples(): number {
        return this.curr.samples;
    }

    constructor(
        private readonly id: string,
        private curr: { min: number; max: number; avg: number; samples: number },
        private startTicks: number,
        private inProgress: boolean,
    ) {}

    start() {
        if (this.inProgress) {
            console.warn("Cannot start. In the middle of an existing timing");
            return;
        }
        this.startTicks = Date.now();
        this.inProgress = true;
    }

    stop() {
        let capture = Date.now() - this.startTicks;
        this.curr.min = Math.min(this.curr.min, capture);
        this.curr.max = Math.max(this.curr.max, capture);
        this.curr.avg = this.curr.avg * 0.95 + capture * 0.05;
        this.curr.samples += 1;
        this.inProgress = false;
    }

    analyze() {
        console.log(
            `Timings Results[${this.id}]: avg=${this.curr.avg} min=${this.curr.min} max=${this.curr.max} `,
        );
        this.reset();
    }

    private reset() {
        this.curr = { ...Timings.Empty };
    }
}

/** checks for null and throw an exception */
export function safe<T, U>(o: T | undefined | null, fn: (obj: T) => U): U | undefined {
    if (o == null) {
        console.warn("null exception prevent");
        return undefined;
    }
    return fn(o);
}

export function tryFail<T>(fn: () => T): T {
    try {
        return fn();
    } catch (e) {
        throw throwError("Unexcepted exception", e);
    }
}
